import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { ServicoJornalService } from "src/app/services/servico-jornal.service";
import { listarServicos, listarServicosFailure, listarServicosSuccess } from "../../actions/Servicos/servico-jornal.action";

@Injectable()
export class ListarServicosEffects {

  public listarServicos$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly servicoJornalService: ServicoJornalService) {
    this.createEffects()
  }

  private createEffects() {
     this.listarServicos$ = createEffect(() => this.actions$.pipe(
       ofType(listarServicos),
       switchMap(() =>
         this.servicoJornalService
           .listarServicos()
           .pipe(
             map(
               response => {
               if (response.erros != undefined && response.erros.length > 0) {
                 return listarServicosFailure({ response })
               }
               return listarServicosSuccess({ response })
             }),
             catchError(() => {
               return of()}
             )
           )
       )
     )
     );
   }
}
